import React, { useMemo, type ReactNode } from 'react';

import { ButtonItem } from '@atlaskit/menu';
import { ModalEntryPointPressableTrigger } from '@atlassian/jira-modal-entry-point-pressable-trigger/src/ModalEntryPointPressableTrigger.tsx';
import type { Product } from '@atlassian/edition-awareness';

import { useTracedUrl } from '../../services/use-traced-url/index.tsx';
import { standardToPremiumModalEntryPoint } from './entrypoint.tsx';

export type StandardToPremiumModalEntrypointTriggerProps = {
	children: ReactNode;
	cloudId: string;
	product: Product;
	experienceUrl?: string;
	learnMoreUrl?: string;
	onClick?: () => void;
};

export const StandardToPremiumModalEntrypointTrigger = ({
	children,
	cloudId,
	product,
	experienceUrl,
	learnMoreUrl,
	onClick,
}: StandardToPremiumModalEntrypointTriggerProps) => {
	// TODO: can remove this logic once edition_awareness_upsell_custom_ea_implementation fg is 100% released
	const { url: learnMoreHref = '' } = useTracedUrl(learnMoreUrl ?? '/admin/billing');
	// admin/billing redirects to the subscription page
	const { url: changeOfferingHref = '' } = useTracedUrl(experienceUrl ?? '/admin/billing');

	const entryPointProps = useMemo(
		() => ({
			cloudId,
			product,
			learnMoreHref,
			changeOfferingHref,
		}),
		[cloudId, product, learnMoreHref, changeOfferingHref],
	);

	return (
		<ModalEntryPointPressableTrigger
			entryPoint={standardToPremiumModalEntryPoint}
			entryPointProps={entryPointProps}
			interactionName="standard-to-premium-modal"
			useInternalModal
			modalProps={{
				width: 'x-large',
				shouldCloseOnOverlayClick: true,
				shouldCloseOnEscapePress: true,
			}}
		>
			{({ ref }) => (
				<ButtonItem onClick={onClick} ref={ref}>
					{children}
				</ButtonItem>
			)}
		</ModalEntryPointPressableTrigger>
	);
};
